import React, { forwardRef, PureComponent } from 'react';

const MissingValueIcon = forwardRef((props, ref) => {
  const { color, backgroundColor, ...rest } = props;

  return (
    <svg
      {...rest}
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      style={{
        width: '100%',
        height: '100%',
        backgroundColor,
        opacity: 0.5,
      }}
    >
      <line x1="0" y1="0" x2="100%" y2="100%" stroke={color} strokeDasharray="4 1" />
      <line x1="0" y1="100%" x2="100%" y2="0" stroke={color} strokeDasharray="4 1" />
    </svg>
  );
});

MissingValueIcon.defaultProps = {
  color: '#999',
  backgroundColor: '#ccc',
};

export default MissingValueIcon;
